<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <transition name="page" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'default-layout',
}
</script>



// WEBPACK FOOTER //
// default.vue?3cdc2ebe